import { aiTools } from './projectData'
import Marquee from "react-fast-marquee";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function ai() {
  return (
    <section className="ai-section">
      <h2 className="ai-title">AI Tools I Use</h2>
      <div className="ai-grid">
         <Row className='justify-content-center'>
          <Col lg={8} md={12}>
           <Marquee speed={40} >
            {aiTools.map((tool, index) => (
              <div key={index} className="ai-card">
                <img src={tool.logo} alt={tool.name} className="ai-logo" />
                <h3>{tool.name}</h3>
                <p>{tool.desc}</p>
              </div>
            ))}
          </Marquee>
          </Col>
         </Row>

      </div>
    </section>
  )
}
